/* ===== main.js ===== */
/* 下鴨茶寮のおせち 2027 LP の JS
   1. スクロール連動のフェードイン（ユーザー指示 2026-10-14、harihari と同じ。Figma に無い演出）
      - 各 section 直下（PC は .inner 直下）の要素に .lp-fade を付け、画面に入ったら .lp-visible を付ける
      - 同じ section 内では順番に 0.08s ずつ遅らせる（上限 0.5s）
      - ファーストビュー（.fv）と、prefers-reduced-motion の環境では何もしない
        （検証用スクリーンショットは Edge/Chrome に --force-prefers-reduced-motion を付けると演出なしで撮れる）
   2. 冷蔵／冷凍タブ（SP）
   3. 横スクロール表の下の帯: つまみの幅＝見えている割合、位置＝スクロール量。
      マウスでも隠れた列が出せるよう、つまみのドラッグ・帯のクリックに対応（ユーザー指示 2026-10-30。表そのものは掴めない: 2026-10-31） */
(function () {
  'use strict';


  /* ---- 1. フェードイン ---- */
  (function fade() {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    if (!('IntersectionObserver' in window)) return;

    var sections = document.querySelectorAll('.osechi2027-lp .lp-main section:not(.fv)');
    var targets = [];
    Array.prototype.forEach.call(sections, function (section) {
      var box = section.querySelector(':scope > .inner') || section;
      var i = 0;
      Array.prototype.forEach.call(box.children, function (el) {
        el.classList.add('lp-fade');
        el.style.transitionDelay = (Math.min(i, 6) * 0.08) + 's';
        targets.push(el);
        i += 1;
      });
    });

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('lp-visible');
        observer.unobserve(entry.target);
      });
    }, { threshold: 0.05, rootMargin: '0px 0px -5% 0px' });

    targets.forEach(function (el) { observer.observe(el); });
  })();

  /* ---- 2. 冷蔵／冷凍タブ ---- */
  (function tabs() {
    var lists = document.querySelectorAll('[role="tablist"]');
    Array.prototype.forEach.call(lists, function (list) {
      var tabs = list.querySelectorAll('[role="tab"]');
      function select(tab) {
        Array.prototype.forEach.call(tabs, function (t) {
          var on = t === tab;
          t.classList.toggle('is-active', on);
          t.setAttribute('aria-selected', on ? 'true' : 'false');
          t.tabIndex = on ? 0 : -1;
          var panel = document.getElementById(t.getAttribute('aria-controls'));
          if (panel) panel.hidden = !on;
        });
      }
      Array.prototype.forEach.call(tabs, function (tab, idx) {
        tab.addEventListener('click', function () { select(tab); });
        tab.addEventListener('keydown', function (e) {
          var next = null;
          if (e.key === 'ArrowRight') next = tabs[(idx + 1) % tabs.length];
          if (e.key === 'ArrowLeft') next = tabs[(idx - 1 + tabs.length) % tabs.length];
          if (next) { e.preventDefault(); select(next); next.focus(); }
        });
      });
    });
  })();

  /* ---- 3. 横スクロール表の帯 ----
     つまみ: 幅＝見えている割合、位置＝スクロール量。
     マウスでも隠れた列が出せるように（ユーザー指示 2026-10-30）:
       - つまみをドラッグ／帯の空きをクリックで移動
       - 表そのものをマウスで掴む動きは付けない（ユーザー指示 2026-10-31「PC はスクロールバーだけでいい」。タッチは従来どおりネイティブ） */
  (function scrollbars() {
    var scrollers = document.querySelectorAll('[data-scroller]');
    Array.prototype.forEach.call(scrollers, function (sc) {
      var thumb = document.querySelector('[data-thumb="' + sc.getAttribute('data-scroller') + '"]');
      if (!thumb) return;
      var track = thumb.parentNode;
      var pad = 0, inner = 0, w = 0;

      function maxScroll() { return Math.max(sc.scrollWidth - sc.clientWidth, 0); }
      function update() {
        pad = parseFloat(getComputedStyle(thumb).left) || 0;
        inner = track.clientWidth - pad * 2;
        var ratio = sc.scrollWidth > 0 ? sc.clientWidth / sc.scrollWidth : 1;
        w = Math.max(inner * ratio, pad * 4);
        var x = maxScroll() > 0 ? (inner - w) * (sc.scrollLeft / maxScroll()) : 0;
        thumb.style.width = w + 'px';
        thumb.style.transform = 'translateX(' + x + 'px)';
        track.classList.toggle('is-scrollable', maxScroll() > 0);
      }
      sc.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);
      if (document.fonts && document.fonts.ready) document.fonts.ready.then(update);
      update();

      if (!('PointerEvent' in window)) return;

      /* つまみのドラッグ */
      var dragStartX = 0, dragStartLeft = 0;
      thumb.addEventListener('pointerdown', function (e) {
        if (e.pointerType === 'mouse' && e.button !== 0) return;
        e.preventDefault();
        e.stopPropagation();
        dragStartX = e.clientX;
        dragStartLeft = sc.scrollLeft;
        try { thumb.setPointerCapture(e.pointerId); } catch (err) { /* 合成イベントなど */ }
        thumb.classList.add('is-dragging');
      });
      thumb.addEventListener('pointermove', function (e) {
        if (!thumb.classList.contains('is-dragging')) return;
        var range = inner - w;
        if (range <= 0) return;
        sc.scrollLeft = dragStartLeft + (e.clientX - dragStartX) * (maxScroll() / range);
      });
      function thumbEnd(e) {
        if (!thumb.classList.contains('is-dragging')) return;
        thumb.classList.remove('is-dragging');
        if (thumb.hasPointerCapture && thumb.hasPointerCapture(e.pointerId)) thumb.releasePointerCapture(e.pointerId);
      }
      thumb.addEventListener('pointerup', thumbEnd);
      thumb.addEventListener('pointercancel', thumbEnd);

      /* 帯の空きをクリック → その位置へ */
      track.addEventListener('pointerdown', function (e) {
        if (e.target === thumb) return;
        if (e.pointerType === 'mouse' && e.button !== 0) return;
        var range = inner - w;
        if (range <= 0) return;
        var x = e.clientX - track.getBoundingClientRect().left - pad - w / 2;
        sc.scrollTo({ left: Math.min(Math.max(x, 0), range) * (maxScroll() / range), behavior: 'smooth' });
      });

    });
  })();

  /* ---- 4. 固定ボタンはファーストビューを通り過ぎたら出す（ユーザー指示 2026-10-31）----
     表示中の .fv の下端が画面上端より上に行ったら .sticky-cta に .is-visible、戻ったら外す。
     判定は IntersectionObserver（フェードインと同じ仕組み。scroll イベントが届かない埋め込み環境でも動く）＋ scroll/resize の保険。
     CSS 側は .is-managed（この JS が付ける）のときだけ隠す（JS が動かない環境では常に表示） */
  (function stickyCta() {
    var bars = document.querySelectorAll('.sticky-cta');
    var fvs = document.querySelectorAll('.fv');
    if (!bars.length || !fvs.length) return;
    Array.prototype.forEach.call(bars, function (bar) { bar.classList.add('is-managed'); });
    function passedFv(fv) {
      if (fv.offsetParent === null) return false;          // display:none 側（SP/PC の非表示側）は無視
      return fv.getBoundingClientRect().bottom <= 0;
    }
    function update() {
      var passed = Array.prototype.some.call(fvs, passedFv);
      Array.prototype.forEach.call(bars, function (bar) { bar.classList.toggle('is-visible', passed); });
    }
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function () { update(); }, { threshold: [0, 0.01] });
      Array.prototype.forEach.call(fvs, function (fv) { io.observe(fv); });
    }
    window.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
  })();
})();
